import query from '../utils/query';

const Auth = () => import('../views/Auth.vue');
const AuthAgency = () => import('../views/Auth/Agency.vue');
const AuthAircall = () => import('../views/Auth/Aircall.vue');
const AuthOAuth = () => import('../views/Auth/OAuth.vue');
const Broadcasts = () => import('../views/Broadcasts.vue');
const BroadcastsCreate = () => import('../views/Broadcasts/Create.vue');
const BroadcastsEdit = () => import('../views/Broadcasts/Edit.vue');
const BroadcastsClone = () => import('../views/Broadcasts/Clone.vue');
const BroadcastsView = () => import('../views/Broadcasts/View.vue');
const Clients = () => import('../views/Clients.vue');
const Dashboard = () => import('../views/Dashboard.vue');
const ErrorsSuspended = () => import('../views/Errors/Suspended.vue');
const ErrorsForcePasswordChange = () => import('../views/Errors/ForcePasswordChange.vue');
const PipedriveExtension = () => import('../views/Pipedrive/Extension.vue');
const Picker = () => import('../views/Picker');
const RegistrationAgency = () => import('../views/Registration/Agency');
const Settings = () => import('views/Settings.vue');
const SettingsBilling = () => import('../views/Settings/Billing.vue');
const SettingsBillingOverview = () => import('../views/Settings/Billing/Overview.vue');
const SettingsCannedMessageCreate = () =>
    import('../views/Settings/Personal/Settings/CannedMessages/CreateCannedMessage.vue');
const SettingsCannedMessageEdit = () =>
    import('../views/Settings/Personal/Settings/CannedMessages/EditCannedMessage.vue');
const SettingsDeveloper = () => import('../views/Settings/Developer.vue');
const SettingsDeveloperApplications = () => import('../views/Settings/Developer/Applications.vue');
const SettingsDeveloperPersonalAccessTokens = () =>
    import('../views/Settings/Developer/PersonalAccessTokens.vue');
const SettingsWidgetChat = () => import('../views/Settings/Widget/Chat.vue');
const SettingsInboxes = () => import('../views/Settings/Organization/Inboxes.vue');
const InboxGroup = () => import('../views/Settings/Organization/Inboxes/InboxGroup.vue');
const SettingsInboxesManage = () => import('../views/Settings/Organization/Inboxes/Manage.vue');
const SettingsIntegrations = () => import('../views/Settings/Integrations.vue');
const SettingsIntegrationsSettings = () => import('../views/Settings/Integrations/Settings.vue');
const SettingsIntegrationsAircallNumber = () =>
    import('../views/Settings/Integrations/SettingsIntegrationsAircallNumber.vue');
const SettingsIntegrationsWebhooks = () =>
    import('../views/Settings/Integrations/SettingsIntegrationsWebhooks.vue');
const SettingsIntegrationsWebhookHistory = () =>
    import('../views/Settings/Integrations/SettingsIntegrationsWebhookHistory.vue');
const SettingsIntegrationsWebhookHistoryDetail = () =>
    import('../views/Settings/Integrations/SettingsIntegrationsWebhookHistoryDetail.vue');
const SettingsIntegrationsWebhookCreate = () =>
    import('../views/Settings/Integrations/SettingsIntegrationsWebhookCreate.vue');
const SettingsOrganizationMembers = () => import('../views/Settings/Organization/Members.vue');
const SettingsOrganizationMembersAdd = () =>
    import('../views/Settings/Organization/Members/InviteMember.vue');
const MemberManage = () => import('../views/Settings/Organization/Members/Manage/MemberManage.vue');
const SettingsOrganizationNumbers = () => import('../views/Settings/Organization/Numbers.vue');
const SettingsOrganizationSettings = () => import('../views/Settings/Organization/Settings.vue');
const SettingsPersonal = () => import('../views/Settings/Personal/Settings.vue');
const SettingsPersonalAuthorizedApps = () =>
    import('../views/Settings/Personal/AuthorizedApps.vue');
const SettingsScheduled = () => import('../views/Settings/Scheduled.vue');
const SettingsTags = () => import('../views/Settings/Organization/Tags.vue');
const SettingsTag = () => import('../views/Settings/Organization/Tag.vue');
const CustomFields = () => import('../views/Settings/Organization/CustomFields.vue');
const SidebarApp = () => import('../views/Sidebar');
const Triggers = () => import('../views/Triggers.vue');
const TriggersView = () => import('../views/Triggers/View');
const KeyWords = () => import('../views/KeyWords.vue');
const KeywordsCreate = () => import('../views/KeyWords/Create.vue');
const KeywordsEdit = () => import('../views/KeyWords/Edit.vue');
const KeywordsClone = () => import('../views/KeyWords/Clone.vue');
const KeywordsView = () => import('../views/KeyWords/View.vue');
const PublicApi = () => import('../views/Settings/PublicApi');
const PublicApiTokens = () => import('../views/Settings/Developer/PublicApiTokens');
const Landline = () => import('../views/Settings/Organization/Numbers/Landline/Landline');
const Zipwhip = () => import('../views/Settings/Organization/Numbers/Zipwhip/Zipwhip');
const LandingMobile = () => import('../views/LandingMobile/Index');
const DlcProfileConfiguration = () =>
    import(
        '../views/Settings/Organization/Settings/DlcProfileConfiguration/DlcProfileConfiguration'
    );
const DlcProfileConfigurationStandard = () =>
    import(
        '../views/Settings/Organization/Settings/DlcProfileConfiguration/DlcProfileConfigurationStandard'
    );
const BusinessProfileConfiguration = () =>
    import(
        '../views/Settings/Organization/Settings/BusinessProfileConfiguration/BusinessProfileConfiguration'
    );
const Compliance = () => import('../views/Settings/Organization/Settings/Compliance.vue');
const TollFree = () => import('../views/Settings/Organization/Settings/TollFree.vue');
const Icons = () => import('../views/Icons');
const Analytics = () => import('../views/Analytics');
const AnalyticsOverall = () => import('../views/Analytics/Overall');
const AnalyticsConversations = () => import('../views/Analytics/Conversations');
const AnalyticsMessages = () => import('../views/Analytics/Messages');
const AnalyticsCreditUsage = () => import('../views/Analytics/CreditUsage');
const AnalyticsCalling = () => import('../views/Analytics/Calling');
const AnalyticsPerformance = () => import('../views/Analytics/Performance');
const AnalyticsContacts = () => import('../views/Analytics/Contacts');
const AnalyticsConversions = () => import('../views/Analytics/Conversions');
const AnalyticsConversion = () => import('../views/Analytics/Conversion');
const SettingsCustomURLShortener = () =>
    import('../views/Settings/Organization/CustomURLShortener');

const SettingsOrganizationTeams = () => import('../views/Settings/Organization/Teams.vue');

const redirect = query('redirect');

export default [
    // LandingMobile
    {
        path: '/landing-mobile',
        name: 'landing-mobile',
        components: {
            default: LandingMobile,
        },
    },

    // Dashboard
    {
        path: '/',
        name: 'dashboard',
        meta: { auth: true },
        redirect: (to) => {
            return {
                path: (redirect && decodeURIComponent(redirect)) || '/conversations',
                query: to.query,
            };
        },
        components: {
            default: Dashboard,
            sidebar: SidebarApp,
        },
    },

    // Registration Additional Organization
    {
        path: '/register/multiorg',
        name: 'register.multiorg',
    },

    // Registration
    {
        path: '/register/:coupon?',
        name: 'register',
        meta: { guest: true },
    },
    {
        path: '/register/:plan/:event/:customer',
        name: 'register.direct',
        meta: { guest: true },
    },
    {
        path: '/auth/accept/:id',
        name: 'auth.accept',
        meta: { guest: true, invitation: true },
    },
    {
        path: '/auth/aircall/:id',
        name: 'auth.aircall',
        meta: { guest: true },
        component: AuthAircall,
    },
    {
        path: '/auth/agency/:id',
        name: 'auth.agency',
        meta: { guest: true },
        component: AuthAgency,
    },
    {
        path: '/agency/register',
        name: 'register.agency',
        meta: { guest: true },
        component: RegistrationAgency,
    },

    // Picker
    {
        path: '/picker',
        name: 'picker',
        meta: { auth: true },
        component: Picker,
    },

    // Pipedrive Extension
    {
        path: '/pipedrive/extension',
        name: 'pipedrive.extension',
        meta: { auth: true, pipedrive: true },
        components: {
            default: PipedriveExtension,
        },
    },

    // Authentication
    {
        path: '/auth',
        redirect: '/auth/login',
        component: Auth,
        children: [
            {
                path: 'login',
                name: 'auth.login',
                meta: { guest: true },
            },
            {
                path: 'forgot',
                name: 'auth.forgot',
                meta: { guest: true },
            },
            {
                path: 'reset/:token',
                name: 'auth.reset',
            },
            {
                path: 'oauth',
                name: 'auth.oauth',
                meta: { auth: true },
                component: AuthOAuth,
            },
        ],
    },

    // Admin
    {
        name: 'admin',
        path: '/admin',
        meta: { developer: true, auth: true },
        components: {
            sidebar: SidebarApp,
        },
        children: [
            {
                path: '/(.*)*',
            },
        ],
    },

    // Discover
    {
        name: 'discover',
        path: '/discover',
        meta: { auth: true },
        components: {
            sidebar: SidebarApp,
        },
        children: [
            {
                path: '*',
            },
        ],
    },

    // Chatbot
    {
        name: 'chatbot',
        path: '/chatbot',
        meta: { auth: true },
        components: {
            sidebar: SidebarApp,
        },
        children: [
            {
                path: '/(.*)*',
            },
        ],
    },

    // Conversations
    {
        name: 'conversations',
        path: '/conversations',
        meta: { auth: true },
        components: {
            sidebar: SidebarApp,
        },
        children: [
            // TODO I'd like to consolidate this into one route.
            {
                path: 'assigned/:id?',
                redirect: (to) => {
                    return `/conversations/${to.params.id ? to.params.id : ''}`;
                },
            },
            {
                path: 'archived/:id?',
                redirect: (to) => {
                    return `/conversations/${to.params.id ? to.params.id : ''}`;
                },
            },
            {
                path: 'participating/:id?',
                redirect: (to) => {
                    return `/conversations/${to.params.id ? to.params.id : ''}`;
                },
            },
            {
                path: 'create',
                name: 'conversations.create',
            },
            {
                path: 'null',
                name: 'conversations.empty',
            },
            {
                path: ':id(\\d+)',
                name: 'conversations.view',
            },
            {
                path: 'calls',
                name: 'conversations.calls',
            },
        ],
    },

    // Contact Importing
    {
        path: '/contacts/import',
        name: 'contacts.import',
        meta: { auth: true, permission: 'can_import_contacts' },
        components: {
            sidebar: SidebarApp,
        },
    },

    // Contacts Merge
    {
        path: '/contacts/duplicate',
        name: 'contacts.duplicate',
        meta: { auth: true },
        components: {
            sidebar: SidebarApp,
        },
    },
    {
        path: '/contacts/unlinked',
        name: 'contacts.unlinked',
        meta: { auth: true },
        components: {
            sidebar: SidebarApp,
        },
    },

    // Contacts
    {
        path: '/contacts/:modal?',
        name: 'contacts',
        meta: { auth: true },
        components: {
            sidebar: SidebarApp,
        },
    },

    // Triggers
    {
        path: '/triggers/:modal?',
        name: 'triggers',
        meta: { auth: true, permission: 'can_manage_triggers' },
        components: {
            default: Triggers,
            sidebar: SidebarApp,
        },
    },
    {
        path: '/triggers/view/:id',
        name: 'triggers.view',
        meta: { auth: true, permission: 'can_manage_triggers' },
        components: {
            default: TriggersView,
            sidebar: SidebarApp,
        },
    },

    // Workflow
    {
        path: '/workflows',
        name: 'workflows',
        meta: {
            auth: true,
        },
        components: {
            sidebar: SidebarApp,
        },
    },
    {
        path: '/workflows/view/:id',
        name: 'workflows.view',
        meta: {
            auth: true,
        },
        components: {
            sidebar: SidebarApp,
        },
    },

    // Clients
    {
        path: '/clients/:modal?',
        name: 'clients',
        meta: { auth: true, permission: 'can_manage_clients' },
        components: {
            default: Clients,
            sidebar: SidebarApp,
        },
    },

    // Paper Planes
    {
        path: '/broadcasts',
        name: 'broadcasts',
        meta: { auth: true, permission: 'can_manage_broadcasts' },
        redirect: '/broadcasts/all',
    },
    {
        path: '/broadcasts/all',
        name: 'broadcasts.default',
        meta: { auth: true, permission: 'can_manage_broadcasts' },
        components: {
            default: Broadcasts,
            sidebar: SidebarApp,
        },
    },
    {
        path: '/broadcasts/one-time',
        name: 'broadcasts.default',
        meta: { auth: true, permission: 'can_manage_broadcasts' },
        components: {
            default: Broadcasts,
            sidebar: SidebarApp,
        },
    },
    {
        path: '/broadcasts/one-time/sms',
        name: 'broadcasts.default',
        meta: { auth: true, permission: 'can_manage_broadcasts' },
        components: {
            default: Broadcasts,
            sidebar: SidebarApp,
        },
    },
    {
        path: '/broadcasts/one-time/ringless',
        name: 'broadcasts.default',
        meta: { auth: true, permission: 'can_manage_broadcasts' },
        components: {
            default: Broadcasts,
            sidebar: SidebarApp,
        },
    },
    {
        path: '/broadcasts/recurring',
        name: 'broadcasts.recurring',
        meta: { auth: true, permission: 'can_manage_broadcasts' },
        components: {
            default: Broadcasts,
            sidebar: SidebarApp,
        },
    },
    {
        path: '/broadcasts/sms',
        name: 'broadcasts.sms',
        meta: { auth: true, permission: 'can_manage_broadcasts' },
        redirect: '/broadcasts/all',
    },
    {
        path: '/broadcasts/ringless',
        name: 'broadcasts.ringless',
        meta: { auth: true, permission: 'can_manage_broadcasts' },
        components: {
            default: Broadcasts,
            sidebar: SidebarApp,
        },
    },
    {
        path: '/broadcasts/create',
        name: 'broadcasts.create',
        meta: { auth: true, permission: 'can_manage_broadcasts' },
        components: {
            default: BroadcastsCreate,
            sidebar: SidebarApp,
        },
    },
    {
        path: '/broadcasts/edit/:id',
        name: 'broadcasts.edit',
        meta: { auth: true, permission: 'can_manage_broadcasts' },
        components: {
            default: BroadcastsEdit,
            sidebar: SidebarApp,
        },
    },
    {
        path: '/broadcasts/clone/:id',
        name: 'broadcasts.clone',
        meta: { auth: true, permission: 'can_manage_broadcasts' },
        components: {
            default: BroadcastsClone,
            sidebar: SidebarApp,
        },
    },
    {
        path: '/broadcasts/view/:id',
        name: 'broadcasts.view',
        meta: { auth: true, permission: 'can_manage_broadcasts' },
        components: {
            default: BroadcastsView,
            sidebar: SidebarApp,
        },
    },

    // KeyWords
    {
        path: '/keywords',
        name: 'keywords',
        meta: { auth: true, permission: 'can_manage_keywords' },
        components: {
            default: KeyWords,
            sidebar: SidebarApp,
        },
    },
    {
        path: '/keywords/create',
        name: 'keywords.create',
        meta: { auth: true, permission: 'can_manage_keywords' },
        components: {
            default: KeywordsCreate,
            sidebar: SidebarApp,
        },
    },
    {
        path: '/keywords/edit/:id',
        name: 'keywords.edit',
        meta: { auth: true, permission: 'can_manage_keywords' },
        components: {
            default: KeywordsEdit,
            sidebar: SidebarApp,
        },
    },
    {
        path: '/keywords/clone/:id',
        name: 'keywords.clone',
        meta: { auth: true, permission: 'can_manage_keywords' },
        components: {
            default: KeywordsClone,
            sidebar: SidebarApp,
        },
    },
    {
        path: '/keywords/view/:id',
        name: 'keywords.view',
        meta: { auth: true, permission: 'can_manage_keywords' },
        components: {
            default: KeywordsView,
            sidebar: SidebarApp,
        },
    },

    // Analytics
    {
        path: '/analytics',
        name: 'analytics',
        meta: { auth: true, permission: 'can_access_analytics' },
        redirect: '/analytics/overall',
        components: {
            default: Analytics,
            sidebar: SidebarApp,
        },
        children: [
            {
                path: 'overall',
                name: 'analytics.overall',
                meta: { permission: 'can_access_analytics' },
                component: AnalyticsOverall,
            },
            {
                path: 'conversations',
                name: 'analytics.conversations',
                meta: { permission: 'can_access_analytics' },
                component: AnalyticsConversations,
            },
            {
                path: 'messages',
                name: 'analytics.messages',
                meta: { permission: 'can_access_analytics' },
                component: AnalyticsMessages,
            },
            {
                path: 'credit-usage',
                name: 'analytics.creditUsage',
                meta: { permission: 'can_manage_billing_settings' },
                component: AnalyticsCreditUsage,
            },
            {
                path: 'calls',
                name: 'analytics.calls',
                meta: { permission: 'can_access_analytics' },
                component: AnalyticsCalling,
            },
            {
                path: 'performance',
                name: 'analytics.performance',
                meta: { permission: 'can_access_analytics' },
                component: AnalyticsPerformance,
            },
            {
                path: 'contacts',
                name: 'analytics.contacts',
                meta: { permission: 'can_access_analytics' },
                component: AnalyticsContacts,
            },
            {
                path: 'conversions',
                name: 'analytics.conversions',
                meta: { permission: 'can_access_analytics' },
                component: AnalyticsConversions,
            },
            {
                path: 'conversions/:id',
                name: 'analytics.conversion',
                meta: { permission: 'can_access_analytics' },
                component: AnalyticsConversion,
            },
        ],
    },

    // Settings
    {
        path: '/settings',
        name: 'settings',
        meta: { auth: true },
        redirect: 'settings/organization/settings/double-opt-in',
        components: {
            default: Settings,
            sidebar: SidebarApp,
        },
        children: [
            // Personal Settings
            {
                path: 'personal/settings/:tab/create',
                name: 'settings.personal.settings.canned-messages.create',
                meta: { permission: 'can_manage_canned_messages' },
                component: SettingsCannedMessageCreate,
            },
            {
                path: 'personal/settings/:tab/edit/:id',
                name: 'settings.personal.settings.canned-messages.edit',
                meta: { permission: 'can_manage_canned_messages' },
                component: SettingsCannedMessageEdit,
            },
            {
                path: 'personal/settings/:tab?',
                name: 'settings.personal.settings',
                meta: { agency: true },
                component: SettingsPersonal,
            },
            {
                path: 'personal/authorized-apps',
                name: 'settings.authorized-apps',
                meta: { agency: true },
                component: SettingsPersonalAuthorizedApps,
            },
            {
                path: 'integrations',
                name: 'settings.integrations',
                component: SettingsIntegrations,
            },
            {
                path: 'integrations/webhooks',
                name: 'settings.integrations.webhooks',
                component: SettingsIntegrationsWebhooks,
            },
            {
                path: 'integrations/webhooks/create',
                name: 'settings.integrations.webhooks.create',
                component: SettingsIntegrationsWebhookCreate,
            },
            {
                path: 'integrations/webhooks/:webhookId/history',
                name: 'settings.integrations.webhooks.history',
                component: SettingsIntegrationsWebhookHistory,
            },
            {
                path: 'integrations/webhooks/:webhookId/history/:historyId',
                name: 'settings.integrations.webhooks.history.detail',
                component: SettingsIntegrationsWebhookHistoryDetail,
            },
            {
                path: 'integrations/webhooks/:webhookId',
                name: 'settings.integrations.webhooks.update',
                component: SettingsIntegrationsWebhookCreate,
            },
            {
                path: 'integrations/:integration',
                name: 'settings.integrations.integration',
                component: SettingsIntegrationsSettings,
            },
            {
                path: 'integrations/:integration/settings',
                name: 'settings.integrations.integration.settings',
                component: SettingsIntegrationsSettings,
            },
            {
                path: 'scheduled',
                name: 'settings.scheduled',
                component: SettingsScheduled,
            },

            // Organization Settings
            {
                path: 'organization/settings',
                redirect: 'organization/settings/double-opt-in',
            },
            {
                path: 'organization/settings/:tab',
                name: 'settings.organization.settings',
                meta: { agency: true },
                component: SettingsOrganizationSettings,
            },
            {
                path: 'organization/members',
                meta: { permission: 'can_manage_members' },
            },
            {
                path: 'organization/members/:tab',
                name: 'settings.organization.members',
                meta: { permission: 'can_manage_members' },
                component: SettingsOrganizationMembers,
            },
            {
                path: 'organization/members/:tab/invite',
                name: 'settings.organization.members.invite',
                meta: { permission: 'can_manage_members' },
                component: SettingsOrganizationMembersAdd,
            },
            {
                path: 'organization/members/:id/:tab',
                name: 'settings.organization.members.manage',
                meta: { permission: 'can_manage_members' },
                component: MemberManage,
            },
            {
                path: 'organization/teams',
                name: 'settings.organization.teams',
                // meta: { permission: 'can_manage_teams' },
                component: SettingsOrganizationTeams,
            },
            {
                path: 'organization/numbers',
                name: 'settings.organization.numbers',
                component: SettingsOrganizationNumbers,
            },
            {
                path: 'organization/inboxes',
                redirect: 'organization/inboxes/all-inboxes',
            },
            {
                path: 'organization/inboxes/:tab',
                name: 'settings.organization.inboxes',
                component: SettingsInboxes,
            },
            {
                path: 'organization/inboxes/group-inboxes/:tab?/:inbox(\\d+)/:modal?',
                name: 'settings.organization.inboxes.group',
                component: InboxGroup,
            },
            {
                path: 'organization/inboxes/all-inboxes/:inbox(\\d+)/:tab?/:modal?',
                name: 'settings.organization.inboxes.manage',
                component: SettingsInboxesManage,
            },
            {
                path: 'organization/inboxes/:tab?/:modal?',
                name: 'settings.organization.inboxes',
                meta: { permission: 'can_access_inboxes' },
                component: SettingsInboxes,
            },
            {
                path: 'organization/custom-url-shortener',
                name: 'settings.organization.custom-url-shortener',
                component: SettingsCustomURLShortener,
            },
            {
                path: 'organization/tags',
                name: 'settings.organization.tags',
                component: SettingsTags,
            },
            {
                path: 'organization/tags/:id',
                name: 'settings.organization.tag',
                component: SettingsTag,
            },
            {
                path: 'organization/custom-fields',
                name: 'settings.organization.custom-fields',
                component: CustomFields,
            },
            {
                path: 'organization/referrals',
                name: 'settings.organization.referrals',
            },
            {
                path: 'organization/compliance',
                name: 'settings.organization.compliance',
                component: Compliance,
            },
            {
                path: 'organization/compliance/business-profile',
                name: 'settings.organization.compliance.business-profile',
                component: Compliance,
            },
            {
                path: 'organization/compliance/local-numbers',
                name: 'settings.organization.compliance.local-numbers',
                component: Compliance,
            },
            {
                path: 'organization/compliance/questionnaire',
                name: 'settings.organization.compliance.questionnaire',
                component: Compliance,
            },
            {
                path: 'organization/compliance/calling',
                name: 'settings.organization.compliance.calling',
                component: Compliance,
            },
            {
                path: 'organization/compliance/toll-free',
                name: 'settings.organization.compliance.toll-free.root',
                component: Compliance,
            },
            {
                path: 'organization/compliance/toll-free/:id',
                name: 'settings.organization.compliance.toll-free',
                component: TollFree,
            },
            {
                path: 'organization/compliance/toll-free/view/:id',
                name: 'settings.organization.compliance.toll-free.view',
                component: TollFree,
            },

            // Billing Settings
            {
                path: 'billing',
                name: 'settings.billing',
                meta: { permission: 'can_manage_billing_settings' },
                component: SettingsBilling,
                children: [
                    {
                        path: 'overview/self_upgrade',
                        name: 'settings.billing.overview.self_upgrade',
                        meta: { permission: 'can_manage_billing_settings' },
                        component: SettingsBillingOverview,
                    },
                    {
                        path: 'overview/upgrade',
                        name: 'settings.billing.overview.upgrade',
                        meta: { permission: 'can_manage_billing_settings' },
                        component: SettingsBillingOverview,
                    },
                    {
                        path: ':modal?',
                        name: 'settings.billing.overview',
                        meta: { permission: 'can_manage_billing_settings' },
                        component: SettingsBillingOverview,
                    },
                ],
            },
            {
                path: 'widget/chat',
                name: 'settings.widget.chat',
                meta: { permission: 'can_manage_website_chat_widget' },
                component: SettingsWidgetChat,
            },
            // Developer Settings
            {
                path: 'developer',
                name: 'settings.developer',
                meta: { auth: true, isPublicApiClient: true },
                redirect: '/settings/developer/applications',
                component: SettingsDeveloper,
                children: [
                    {
                        path: 'applications',
                        name: 'settings.developer.applications',
                        component: SettingsDeveloperApplications,
                    },
                    {
                        path: 'access-tokens',
                        name: 'settings.developer.access_tokens',
                        component: SettingsDeveloperPersonalAccessTokens,
                    },
                ],
            },
        ],
    },

    // integrations aircall number
    {
        path: '/settings/integrations/aircall/number',
        name: 'settings.integrations.integration.number',
        meta: { auth: true },
        components: {
            default: SettingsIntegrationsAircallNumber,
            sidebar: SidebarApp,
        },
    },

    // Suspended
    {
        path: '/suspended',
        name: 'suspended',
        meta: { auth: true },
        component: ErrorsSuspended,
    },
    // Force Password Change
    {
        path: '/auth/password-change/force',
        name: 'force-password-change',
        meta: { auth: true },
        component: ErrorsForcePasswordChange,
    },

    // Landline
    {
        path: '/landline',
        name: 'landline',
        meta: { permission: 'can_create_additional_inboxes' },
        components: {
            default: Landline,
            sidebar: SidebarApp,
        },
    },
    {
        path: '/settings/organization/numbers/text-enable-landline',
        name: 'settings.organization.numbers.text-enable-landline',
        meta: { permission: 'can_create_additional_inboxes' },
        components: {
            default: Landline,
            sidebar: SidebarApp,
        },
    },
    {
        path: '/settings/organization/numbers/text-enable-landline/steps',
        name: 'settings.organization.numbers.text-enable-landline.steps',
        meta: { permission: 'can_create_additional_inboxes' },
        components: {
            default: Landline,
            sidebar: SidebarApp,
        },
    },
    {
        path: '/settings/organization/numbers/text-enable-landline/steps/enter-number',
        name: 'settings.organization.numbers.text-enable-landline.steps.enter-number',
        meta: { permission: 'can_create_additional_inboxes' },
        components: {
            default: Landline,
            sidebar: SidebarApp,
        },
    },
    {
        path: '/settings/organization/numbers/text-enable-landline/steps/enter-address',
        name: 'settings.organization.numbers.text-enable-landline.steps.enter-address',
        meta: { permission: 'can_create_additional_inboxes' },
        components: {
            default: Landline,
            sidebar: SidebarApp,
        },
    },
    {
        path: '/settings/organization/numbers/text-enable-landline/steps/verify-number',
        name: 'settings.organization.numbers.text-enable-landline.steps.verify-number',
        meta: { permission: 'can_create_additional_inboxes' },
        components: {
            default: Landline,
            sidebar: SidebarApp,
        },
    },
    {
        path: '/settings/organization/numbers/text-enable-landline/steps/assign-number',
        name: 'settings.organization.numbers.text-enable-landline.steps.assign-number',
        meta: { permission: 'can_create_additional_inboxes' },
        components: {
            default: Landline,
            sidebar: SidebarApp,
        },
    },
    {
        path: '/settings/organization/numbers/text-enable-landline/steps/authorization-document',
        name: 'settings.organization.numbers.text-enable-landline.steps.authorization-document',
        meta: { permission: 'can_create_additional_inboxes' },
        components: {
            default: Landline,
            sidebar: SidebarApp,
        },
    },

    // Zipwhip
    {
        path: '/zipwhip',
        name: 'zipwhip',
        meta: { permission: 'can_create_additional_inboxes' },
        components: {
            default: Zipwhip,
            sidebar: SidebarApp,
        },
    },

    // 10DlcProfile
    {
        path: '/settings/organization/settings/profile/10dlc-profile',
        name: 'settings.organization.settings.profile.10dlc-profile',
        components: {
            default: DlcProfileConfiguration,
            sidebar: SidebarApp,
        },
    },
    {
        path: '/settings/organization/settings/profile/10dlc-profile-standard',
        name: 'settings.organization.settings.profile.10dlc-profile-standard',
        meta: { permission: 'can_manage_organization_settings' },
        components: {
            default: DlcProfileConfigurationStandard,
            sidebar: SidebarApp,
        },
    },

    // Business Profile
    {
        path: '/settings/organization/settings/profile/business',
        name: 'settings.organization.settings.profile.business',
        components: {
            default: BusinessProfileConfiguration,
            sidebar: SidebarApp,
        },
    },

    // Icons View
    {
        path: '/icons-view',
        name: 'icons.view',
        components: {
            default: Icons,
        },
    },
];
